import { IOption } from 'components/Select/type';
import { IQuestion } from 'types/Question.types';

// The dealer-panel response returns questions as { key: label } (regular AND extra
// price questions merged into one object). The value is the display label.
export const parseQuestionsObjectResponseIntoArray = (questionsObj: object) => {
  return Object.keys(questionsObj).map((questionKey: string) => {
    const value = (questionsObj as Record<string, any>)[questionKey];
    const isObject = value && typeof value === 'object';
    return {
      ...(isObject ? value : {}),
      name: isObject ? value.name ?? questionKey : value ?? questionKey,
      initialKey: isObject ? value.initialKey ?? questionKey : questionKey,
    };
  });
};

export const SHOW_QUESTION_PRICES_ON_DOCUMENTS_INITIAL_KEY =
  'showQuestionPricesOnDocuments';

export const formatQuestionDisplayName = (name: string): string =>
  (name ?? '').replace(/^Q_/, '').replace(/_/g, ' ');

export const getInitialValuesFromQuestions = (
  questions: IQuestion[],
  documentVisibilityData: any,
  documentVisibilityOptions: IOption[]
) => {
  const fetchedVisibilityData =
    documentVisibilityData?.data?.document_visibility_options;

  // Has any visibility ever been saved for this model? When nothing is saved yet
  // (fresh model, null/empty response) every question defaults to fully visible.
  // Once something is saved, the form stores all then-existing question keys, so a
  // question whose key is absent was added after the last save (never applied) and
  // stays empty — matching BP hiding keys it can't find in the saved data.
  const hasSavedVisibility =
    !!fetchedVisibilityData && Object.keys(fetchedVisibilityData).length > 0;

  const initialValues: Record<string, any> = {};
  const allSelectedDefaultValue = documentVisibilityOptions.map(
    (option) => option.value
  );

  questions.forEach((question: IQuestion) => {
    const savedValue = fetchedVisibilityData?.[question.initialKey];
    if (savedValue) {
      initialValues[question.initialKey] = savedValue;
    } else {
      initialValues[question.initialKey] = hasSavedVisibility
        ? []
        : allSelectedDefaultValue;
    }
  });

  if (fetchedVisibilityData?.[SHOW_QUESTION_PRICES_ON_DOCUMENTS_INITIAL_KEY]) {
    initialValues[SHOW_QUESTION_PRICES_ON_DOCUMENTS_INITIAL_KEY] =
      fetchedVisibilityData[SHOW_QUESTION_PRICES_ON_DOCUMENTS_INITIAL_KEY];
  } else {
    initialValues[SHOW_QUESTION_PRICES_ON_DOCUMENTS_INITIAL_KEY] = [];
  }

  return initialValues;
};
